import React from "react";

function IconUpdate() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M12.38 4.76A7.25 7.25 0 005.72 8.375a.75.75 0 01-.15.185l2.58-.596a.75.75 0 11.338 1.462l-3.16.73A1.75 1.75 0 013.23 8.843l-.729-3.16a.75.75 0 111.462-.337l.507 2.197a8.75 8.75 0 0115.524.897.75.75 0 01-1.37.61A7.25 7.25 0 0012.38 4.76zm6.29 9.085a1.75 1.75 0 012.1 1.311l.729 3.16a.75.75 0 11-1.461.337l-.508-2.197a8.75 8.75 0 01-15.523-.897.75.75 0 011.37-.61 7.25 7.25 0 0012.902.676.75.75 0 01.15-.185l-2.58.596a.75.75 0 01-.338-1.462l3.16-.73z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconUpdate;
